import { InputControlType } from '@wix/events-types';
import { INPUT_CONTROLS, INPUT_NAMES } from './constants';
export var getInputControlMeta = function (control) {
    var id = control.id, label = control.label;
    var _a = control.inputs[0], name = _a.name, additionalLabels = _a.additionalLabels, options = _a.options, maxLength = _a.maxLength;
    return {
        mandatory: isControlRequired(control),
        label: label,
        options: options,
        additionalLabels: additionalLabels,
        maxLength: maxLength,
        id: id,
        name: name,
    };
};
export var getFirstNameControlMeta = function (control) {
    var id = control.id;
    var _a = control.inputs[0], name = _a.name, maxLength = _a.maxLength, label = _a.label;
    return {
        id: id,
        name: name,
        label: label,
        mandatory: isControlRequired(control),
        maxLength: maxLength,
    };
};
export var getLastNameControlMeta = function (control) {
    var id = control.id;
    var _a = control.inputs[1], name = _a.name, maxLength = _a.maxLength, label = _a.label;
    return {
        id: id,
        name: name,
        label: label,
        mandatory: isControlRequired(control),
        maxLength: maxLength,
    };
};
export var getGuestNamesCaptions = function (control) { var _a, _b; return (_b = (_a = control.inputs[1]) === null || _a === void 0 ? void 0 : _a.additionalLabels) !== null && _b !== void 0 ? _b : {}; };
export var getGuestNamesMaxLength = function (control) { var _a, _b; return (_b = (_a = control.inputs[1]) === null || _a === void 0 ? void 0 : _a.maxLength) !== null && _b !== void 0 ? _b : 50; };
export var isSystemControl = function (control) { return control.system; };
export var getControlInputs = function (control) { return control.inputs; };
export var getControlName = function (control) { return control.id.split('-')[0]; };
export var getControlType = function (control) { return control.type; };
export var isAddressControl = function (control) {
    return isFullAddressControl(control) || isShortAddressControl(control);
};
export var isFullAddressControl = function (control) {
    return getControlType(control) === InputControlType.ADDRESS_FULL;
};
export var isShortAddressControl = function (control) {
    return getControlType(control) === InputControlType.ADDRESS_SHORT;
};
export var isNameControl = function (control) {
    return getControlType(control) === InputControlType.NAME;
};
export var isDateControl = function (control) {
    return getControlType(control) === InputControlType.DATE;
};
export var isGuestsControl = function (control) {
    return getControlType(control) === InputControlType.GUEST_CONTROL;
};
export var isSingleGuestControl = function (control) {
    return getInputControlMeta(control).options.length === 2;
};
export var isCommentControl = function (control) {
    return getControlName(control) === INPUT_CONTROLS.COMMENT;
};
export var isControlRequired = function (control) {
    if (isGuestsControl(control)) {
        return !!control.inputs.find(function (input) { return input.name === INPUT_NAMES.GUEST_NAMES && input.mandatory; });
    }
    return control.system || control.inputs.every(function (input) { return input.mandatory; });
};
//# sourceMappingURL=selectors.js.map